import { useSelectableContractTypes } from "../../../common/hooks/useSelectableItemQueries.ts";
import { DotLegalSelect } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import { ContractModel } from "../Contract.types.ts";
import { useTranslation } from "../../../localization/useTranslation.ts";

export interface ContractTypeFieldProps {
    /** Lets a caller that owns the vertical rhythm itself turn the field's own margin off. */
    noMargin?: boolean;
    /** Puts the label above the input with the help icon beside it, for a form laid out that way. */
    useFixedLabel?: boolean;
    /** Suppresses the field's help icon, for a view where the same field is shown twice. */
    hideToolTip?: boolean;
    isLoading: boolean;
    onChange: (changeFunc: (contract: ContractModel) => void) => Promise<void>;
    readOnly: boolean;
    required: boolean;
    contractTypeId: string | undefined;
    disabled: boolean;
    isPreview: boolean;
    errorText?: string;
}

function ContractTypeField(props: ContractTypeFieldProps) {
    const { translateString } = useTranslation();
    let selectableContractTypesQuery = useSelectableContractTypes(!props.isPreview);

    return (
        <DotLegalSelect
            noMargin={props.noMargin}
            useFixedLabel={props.useFixedLabel}
            options={selectableContractTypesQuery.data}
            isLoading={(props.isLoading || selectableContractTypesQuery.isLoading) && !props.readOnly}
            onChange={
                props.readOnly
                    ? () => {}
                    : (value) =>
                          props.onChange((c) => {
                              c.contractTypeId = value === null ? undefined : value;
                          })
            }
            label={translateString("contractType")}
            noOptionsLabel={""}
            toolTipText={props.hideToolTip ? undefined : translateString("addContractTypeTooltip")}
            disableClearable={props.required}
            selectedItem={props.contractTypeId}
            disabled={props.disabled}
            errorText={props.errorText}
        />
    );
}

export default ContractTypeField;
